import { supabase } from './client';

export interface EmpresaConfig {
  id?: string;
  empresa_id: string;
  saldo_inicial: number;
  data_saldo_inicial: string;
  atualizado_em?: string;
}

export async function getEmpresaConfig(empresaId: string): Promise<EmpresaConfig | null> {
  try {
    const { data, error } = await supabase
      .from('empresa_config')
      .select('*')
      .eq('empresa_id', empresaId)
      .single();

    if (error) {
      if (error.code === 'PGRST116') {
        return null;
      }
      console.error('Erro ao buscar configuração da empresa:', error);
      return null;
    }

    return data as EmpresaConfig;
  } catch (error) {
    console.error('Erro ao buscar configuração da empresa:', error);
    return null;
  }
}

export async function atualizarSaldoInicial(
  empresaId: string,
  saldoInicial: number,
  dataSaldoInicial: string
): Promise<{ ok: boolean; data?: EmpresaConfig; error?: string }> {
  try {
    const { data: existingConfig } = await supabase
      .from('empresa_config')
      .select('id')
      .eq('empresa_id', empresaId)
      .single();

    if (existingConfig) {
      const { data, error } = await supabase
        .from('empresa_config')
        .update({
          saldo_inicial: saldoInicial,
          data_saldo_inicial: dataSaldoInicial,
          atualizado_em: new Date().toISOString(),
        })
        .eq('empresa_id', empresaId)
        .select()
        .single();

      if (error) {
        console.error('Erro ao atualizar saldo inicial:', error);
        return { ok: false, error: error.message };
      }

      return { ok: true, data: data as EmpresaConfig };
    } else {
      const { data, error } = await supabase
        .from('empresa_config')
        .insert({
          empresa_id: empresaId,
          saldo_inicial: saldoInicial,
          data_saldo_inicial: dataSaldoInicial,
          atualizado_em: new Date().toISOString(),
        })
        .select()
        .single();

      if (error) {
        console.error('Erro ao criar configuração da empresa:', error);
        return { ok: false, error: error.message };
      }

      return { ok: true, data: data as EmpresaConfig };
    }
  } catch (error: any) {
    console.error('Erro ao atualizar saldo inicial:', error);
    return { ok: false, error: error.message || 'Erro ao atualizar saldo inicial' };
  }
}
